import { CancelFunctions, CodeNameModel } from 'components/common/types';
import { getAgency, getSpecialist, getProductFormats } from 'modules/api/content';
import { getContentDealIdLookupData } from 'modules/api/lookups';
import Local from 'modules/Local';
import {
  Advertiser,
  AdvertiserWithBrands,
  BrandWithProductCategory,
  SelectedBrand,
} from 'components/common/types/Deal.types';
import { AsyncSelectLoadDataHandler } from 'lib/AsyncSelect/AsyncSelect.types';

import DataListProps from 'lib/DataList/DataList.types';
import { normalize } from './utils';

export const loadAgencyLookupData = async (
  cancelFunctions: CancelFunctions,
  _dropdownName: string,
  query: string,
): Promise<[]> => {
  if (query.length < 2) return [];

  try {
    return await getAgency(cancelFunctions, Local.getEnvironmentId(), query);
  } catch (error) {
    return [];
  }
};

export const loadSpecialistLookupData = async (
  cancelFunctions: CancelFunctions,
  _dropdownName: string,
  query: string,
): Promise<[]> => {
  if (query.length < 2) return [];

  try {
    return await getSpecialist(cancelFunctions, Local.getEnvironmentId(), query);
  } catch (error) {
    return [];
  }
};

export const loadProductFormatLookupData = async (
  cancelFunctions: CancelFunctions,
  _dropdownName: string,
  query: string,
): Promise<[]> => {
  if (query.length < 2) return [];

  try {
    return await getProductFormats(cancelFunctions, Local.getEnvironmentId(), query);
  } catch (error) {
    return [];
  }
};

export const loadDealIdLookupData = async ({
  cancelFunctions,
  environment = Local.getEnvironmentId(),
  query = null,
  dspCode = [],
  isCreativeDeal = true,
  bookingStatusCodes = [],
}: {
  cancelFunctions: CancelFunctions;
  environment?: string;
  query?: string | null;
  dspCode: string[];
  isCreativeDeal?: boolean;
  bookingStatusCodes: string[];
}): Promise<DataListProps[]> => {
  try {
    return await getContentDealIdLookupData(
      cancelFunctions,
      environment,
      query,
      dspCode,
      isCreativeDeal,
      bookingStatusCodes,
    );
  } catch (error) {
    return [];
  }
};

export const loadBrandsData = async (
  advertiser: Advertiser | AdvertiserWithBrands | null,
  onLoadBrands: AsyncSelectLoadDataHandler<BrandWithProductCategory>,
  _dropdownName: string,
  query: string,
): Promise<BrandWithProductCategory[]> => {
  const brands = advertiser?.brands;

  if (brands?.length) {
    const normalizedQuery = normalize(query);
    return Promise.resolve(brands.filter(({ name }) => normalize(name).includes(normalizedQuery)));
  }
  return onLoadBrands(_dropdownName, query);
};

export const loadAdvertisersData = async (
  brand: BrandWithProductCategory | SelectedBrand | null,
  onAssetLookup: AsyncSelectLoadDataHandler<CodeNameModel>,
  _dropdownName: string,
  query: string,
): Promise<Advertiser[]> => {
  const advertisers = brand?.advertisers;

  if (advertisers?.length) {
    const normalizedQuery = normalize(query);
    return Promise.resolve(advertisers.filter(({ name }) => normalize(name).includes(normalizedQuery)) as Advertiser[]);
  }
  return onAssetLookup(_dropdownName, query);
};
